import { render, staticRenderFns } from "./PopUpdateSW.vue?vue&type=template&id=2ba0e836"
import script from "./PopUpdateSW.vue?vue&type=script&lang=js"
export * from "./PopUpdateSW.vue?vue&type=script&lang=js"
import style0 from "./PopUpdateSW.vue?vue&type=style&index=0&id=2ba0e836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports